package com.essntl.features.contact.data.supabase

import com.essntl.features.address.data.supabase.AddressDto
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.organization.data.supabase.OrganizationDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ContactDto(
    val id: String,
    @SerialName("last_name")
    val lastName: String?,
    @SerialName("first_name")
    val firstName: String?,
    val email: String? = null,
    @SerialName("phone_number")
    val phoneNumber: String? = null,
    @SerialName("address_id_data")
    val address: AddressDto? = null,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String,
    val notes: String? = null,
    @SerialName("organization_id_data")
    val organization: OrganizationDto? = null,
    val salutation: String? = null,
    @SerialName("date_of_birth")
    val dateOfBirth: String? = null,
) {
    fun toModel() =
        ContactModel(
            id = id,
            firstName = firstName,
            lastName = lastName,
            email = email,
            phoneNumber = phoneNumber,
            address = address?.toModel(),
            createdAt = createdAt,
            updatedAt = updatedAt,
            notes = notes,
            organization = organization?.toModel(),
            salutation = salutation,
            dateOfBirth = dateOfBirth,
        )

    companion object {
        const val COLUMNS_VALUE =
            "*, address_id_data:address_id(*), organization_id_data:organization_id(${OrganizationDto.COLUMNS_VALUE})"

        fun getColumns() = Columns.Companion.raw(COLUMNS_VALUE)
    }
}